import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';

function ModalEmptyHall() {
  const { t } = useTranslation();

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <>
              <h1>{t('kiosk.kioskBlock')}</h1>
              <p>{t('kiosk.kioskBlockMessage1')}</p>
              <p>
                <strong>{t('kiosk.kioskBlockMessage2')}</strong>
              </p>

              <div className="react-confirm-alert-button-group"></div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalEmptyHall;
